import { ApiDomainHoster } from "@incendium/api";
import { MenuItem, Stack, Typography } from "@mui/material";
import { SubdomainStatusLabel } from "features/subdomains";
import { getSelectableSubdomains } from "features/subdomains/utils";
import { useSubdomains } from "Hooks/useSubdomains";
import { SelectValidator } from "react-material-ui-form-validator";

interface ISubdomainSelectorProps {
  subdomainId?: number;
  setSubdomainId: (v: number | undefined) => void;
  helperText?: string;
  optional?: boolean;
}

function SubdomainSelector({
  subdomainId,
  setSubdomainId,
  helperText,
  optional = false,
}: ISubdomainSelectorProps) {
  const { subdomains } = useSubdomains();
  const selectable = getSelectableSubdomains(subdomains || []);

  return (
    <SelectValidator
      size={"small"}
      variant="outlined"
      fullWidth
      label="Which Subdomain"
      helperText={helperText}
      name="subdomainId"
      validators={optional ? [] : ["required"]}
      errorMessages={optional ? [] : ["Subdomain is required."]}
      value={subdomainId ?? ""}
      onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;
        setSubdomainId(value === "" ? undefined : Number(value));
      }}
    >
      {optional && (
        <MenuItem value="">
          <em>Choose later</em>
        </MenuItem>
      )}
      {selectable.map((sd) => (
        <MenuItem key={sd.id} value={sd.id}>
          <Stack
            sx={{ width: "100%" }}
            direction={"row"}
            spacing={1}
            justifyContent={"space-between"}
            alignItems="center"
          >
            <Typography variant="inherit">
              {sd.subdomain} - {sd.name}
            </Typography>
            <SubdomainStatusLabel
              status={sd.status!}
              isCloudflare={
                sd.hoster === ApiDomainHoster.DOMAIN_HOSTER_CLOUDFLARE
              }
            />
          </Stack>
        </MenuItem>
      ))}
    </SelectValidator>
  );
}

export default SubdomainSelector;
